import React from 'react';
import { Icons } from '../../components/atoms/SVG';
import { WidgetType } from '../../types/api/ElementType';
import { ContextWidget } from '../../types/api/Widget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { CalendarBlock } from '../../_blocks/Calendar/CalendarBlock';

export type CalendarWidget = ContextWidget<CalendarBlock, WidgetType.calendar>;

export function CalendarWidget(props: CalendarWidget) {
  const { t } = useSonTranslation('Calendar');
  return <DefaultContextWidget icon={Icons.CALENDAR} title={t('widget.headline')} {...props} />;
}
